var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150.001,
    height: 149.815,
    viewBox: "0 0 150.001 149.815",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20933",
    "data-name": "Path 20933",
    d: "M331.471,350.311c0,15.978.032,30.98-.041,45.973a29.227,29.227,0,0,1-.789,7.505,12.278,12.278,0,0,1-23.532.105,28.84,28.84,0,0,1-.806-7.5c-.073-15.01-.041-30.02-.041-45.786-2.263-.106-4.306-.285-6.349-.285-14.237-.033-28.465.041-42.7-.065-5.478-.041-9.808-2.328-12.152-7.562-2.125-4.754-1.767-9.817,2.092-12.909a21.687,21.687,0,0,1,12.006-4.477c15.368-.512,30.76-.2,46.82-.2.105-2.384.269-4.436.277-6.5.025-13.65-.041-27.292.033-40.943.041-9.271,5.071-15.018,12.8-14.872,7.513.138,12.307,5.747,12.356,14.749.073,15.564.016,31.127.016,47.553H338.1c13.651.008,27.3-.049,40.951.024,8.986.049,14.595,4.859,14.717,12.372.13,7.733-5.608,12.747-14.888,12.788-13.455.073-26.91.025-40.365.025Z",
    transform: "translate(-243.766 -262.798)",
    fill: "#674188"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.43921853a09aba553f1a14b20ebf8ca9.svg";
export { ForwardRef as ReactComponent };